import EnergiaSolar from '../components/templates/EnergiaSolar';

export default function EnergiaSolarPage() {
  return <EnergiaSolar />;
}
